<template>
  <div >
    <Cards class="margin-center" :posts="posts" />
  </div>
</template>

<script>
import {ref} from 'vue'
import getPosts from '@/composables/getposts'
import Cards from '@/components/Cards'
import HeroMedium from '@/components/HeroMedium'
export default {
  components: {HeroMedium, Cards },
  setup() {
    const activities = ref([])
    const error = ref('')
    const { posts } = getPosts()

    return {  posts, activities, error }
  }
  }
</script>

<style>

 

</style>





